import React from 'react';
import { motion } from 'framer-motion';

const LoadingDots = ({ spinningRadius, heightWidthPx }) => {
  const COLORS = ['#ffffff', '#7746F3', '#00C890', '#FBA700', '#F7007F'];
  const NUM_DOTS = COLORS.length;
  const DURATION = 2;
  const RADIUS = spinningRadius;
  // const RADIUS = 20;
  return (
    <div
      // className={`relative w-[${heightWidthPx}] h-[${heightWidthPx}] flex items-center justify-center`}
      className={`relative w-full h-full flex items-center justify-center`}
    >
      {/* <div className="relative w-[80px] h-[80px] flex items-center justify-center"> */}
      <motion.div
        animate={{ rotate: [0, 360] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
        className="relative w-full h-full flex items-center justify-center"
      >
        {COLORS.map((color, i) => {
          const angle = (i / NUM_DOTS) * Math.PI * 2;
          return (
            <motion.div
              key={i}
              initial={{ x: 0, y: 0 }}
              animate={{
                x: [0, Math.cos(angle) * RADIUS, 0],
                y: [0, Math.sin(angle) * RADIUS, 0],
              }}
              transition={{ duration: DURATION, repeat: Infinity, ease: 'easeInOut' }}
              className="absolute w-2 h-2 rounded-full shadow-lg"
              style={{ backgroundColor: color }}
            />
          );
        })}
      </motion.div>
    </div>
  );
};

export default LoadingDots;
